module.exports = __webpack_public_path__ + "img/airship_part.c9a3702d.png";